import React, { useEffect } from "react";
import MaterialTable from "material-table";
import {
  Stack,
  Grid,
  Card,
  Box,
  CardContent,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { monthlySumOfBuildindg } from "../../../../redux/actions/GuestActions";
import { getAllBuildings } from "redux/actions/RatActions";
import { getRecentTransaction } from "redux/actions/PaymentActions";
export default function AvailableRooms() {
  const currentMonthSum = useSelector(
    (state) => state.GuestInfo.currentMonthSum
  );
  const building = useSelector((state) => state.buildings.allBuildings);
  const transaction = useSelector((state) => state.payments.recentPayments);

  const dispatch = useDispatch();
  const columns = [
    {
      title: "Guest Name",
      field: "guestName",
      type: "text",
    },
    {
      title: "Bed ID",
      field: "bedId",
    },
    {
      title: "Amount Paid",
      field: "amountPaid",
      type: "text",
      render: (rowdata) => <p>{rowdata.amountPaid.toFixed()}/-</p>,
    },
    {
      title: "Transaction ID",
      field: "transactionId",
    },
    {
      title: "Transaction Date",
      field: "transactionDate",
      type: "date",
      dateSetting: { locale: "en-GB" },
    },
    {
      title: "Building Name ",
      field: "buildingName",
    },
  ];

  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  console.log(userData);
  let bId = userData.data.buildingId;
  const [buildingsName, setBuildingName] = React.useState("");
  useEffect(() => {
    dispatch(getAllBuildings());
    dispatch(monthlySumOfBuildindg(bId));
    dispatch(getRecentTransaction(bId));
  }, []);
  return (
    <div
      style={{
        height: 400,
        width: "100%",
        padding: "20px",
        marginBottom: "20px",
      }}
    >
      {userData.data.userType === "admin"}
      <Grid
        container
        spacing={3}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={8} lg={8}>
          {userData.data.userType === "admin" ? (
            <Grid item lg={6} md={6} xs={12}>
              <label value="Select Building: ">Select Building: </label>
              <Select
                sx={{ minHeight: 44 }}
                style={{ width: "50%", height: "10%" }}
                name="building"
              >
                {building.map((post) => {
                  return (
                    <MenuItem
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                      value={post.buildingId}
                      onClick={(e) => {
                        dispatch(monthlySumOfBuildindg(e.target.dataset.value));
                        dispatch(getRecentTransaction(e.target.dataset.value));
                        setBuildingName(post.buildingName);
                      }}
                    >
                      {" "}
                      {post.buildingName}{" "}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
          ) : (
            <Grid></Grid>
          )}
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={3}>
          <Card
            sx={{
              display: "flex",
              borderRadius: "20px",
              boxShadow: "0 6px 4px #000000",
            }}
          >
            {userData.data.userType === "admin" && (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <CardContent sx={{ flex: "1 0 auto" }}>
                  <small>
                    This Month Income<h4>{buildingsName}</h4>
                  </small>
                  <Typography compnent="div" variant="h5">
                    <strong style={{ color: "green" }}>
                      ₹{currentMonthSum}/-
                    </strong>
                  </Typography>
                </CardContent>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>

      <Grid>
        <MaterialTable
          title="This Month Transactions"
          data={transaction}
          columns={columns}
          options={{
            exportButton: true,
            actionsColumnIndex: -1,
            paging: false,
            headerStyle: {
              backgroundColor: "#1E90FF",
              color: "white",
              fontSize: "15px",
            },
            rowStyle: {
              fontSize: 16,
            },
          }}
        />
      </Grid>
      <br></br>
      <br></br>
    </div>
  );
}
